
import { Component, Mixins } from "vue-property-decorator";
import { UserDefinedInformationWindowKinds, UserDefinedItemSelectBehavior, ILinkedObjectSpecifiable } from "../../../../../../documaker/domain/format/objects";
import { IUserDefinedItemSelectBehaviorPropertyEditable, instanceOfIUserDefinedItemSelectBehaviorPropertyEditable } from "../../../../../domain/editableFormat/properties";

@Component
export default class UserDefinedItemSelectBehaviorPropertyEditableMixin extends Mixins() {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: IUserDefinedItemSelectBehaviorPropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IUserDefinedItemSelectBehaviorPropertyEditable) => T, defaultValue: T) => T;

  // ドメイン層のエンティティは全てinterfaceにしてるが、
  // 本体のコンポーネントは従来のクラスエンティティで実装されてるのでそっちに合わせないと既存部品を再利用できない。
  // Vueの世界の話なのでコンポーネント側の実装で吸収する。

  get isUserDefinedItemSelectBehaviorEditable(): boolean {
    return this.readPropertyOrDefault(s => instanceOfIUserDefinedItemSelectBehaviorPropertyEditable(s) && s.userDefinedItemSelectBehavior().isEditable(), false);
  }

  get userDefinedItemSelectBehavior(): UserDefinedItemSelectBehavior {
    return this.readPropertyOrDefault(s => UserDefinedItemSelectBehavior.from(s.userDefinedItemSelectBehavior().getValue()), new UserDefinedItemSelectBehavior(UserDefinedInformationWindowKinds.Normal, true));
  }

  set userDefinedItemSelectBehavior(value: UserDefinedItemSelectBehavior) {
    this.writePropertyWhenValid(s => s.userDefinedItemSelectBehavior().setValue(UserDefinedItemSelectBehavior.to(value)));
  }

  get linkedObjectIdentifier(): ILinkedObjectSpecifiable {
    return this.readPropertyOrDefault(s => s.toLinkedObjectIdentifier(), { type: "", id: null, key: "" });
  }
}
